 <template>
  <div>
    <CustomCard
      header="Tax Fund"
      subHeader="List of all tax fund.">
      <template v-slot:body>
        <Full
          @create="setCreate()"
          :noCreateButton="!isAccessible($options.TaxFundPermissions.ADD.id)"
          noPagination
          placeholder="Search Tax Fund"
          buttonLabel="Create Tax Fund"
          :filter="filters.taxFund"
          :table="tables.taxFunds">
          <template #other-filter>
            <div class="tax-fund__filter">
              <b-form-datepicker
                @input="onChangeDateFilters()"
                placeholder="Date From" 
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                class="tax-fund__date-picker"
                v-model="filters.taxFund.dateFrom"/>
              <span class="tax-fund__label">-</span>
              <b-form-datepicker
                @input="onChangeDateFilters()"
                placeholder="Date To"
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
                class="tax-fund__date-picker"
                v-model="filters.taxFund.dateTo"/>
            </div>
          </template>
        </Full>
      </template>
    </CustomCard>
    <TaxFundEntry
      @save="onTaxFundEntry()"
      @close="showModalEntry = false"
      :show="showModalEntry"
      :form="forms.taxFund"
      :mode="entryMode" />
    <DeleteConfirmation
      @close="showModalConfirmation = false"
      @yes="onTaxFundDelete()"
      :show="showModalConfirmation"
      :isProcessing="forms.taxFund.isProcessing"
      name="Tax Fund" />
  </div>
</template>
<script>
const taxFundFields = {
  id: null,
  description: null,
  debit: null,
  credit: null
}
import { CustomCard, DeleteConfirmation } from './../../components'
import Full from '../../components/Full'
import TaxFundEntry from './TaxFundEntry'
import { clearFields, formatNumber, reset, showNotification, validate } from '../../../helpers/forms' 
import { TaxFundApi } from '../../../mixins/api'
import tables from '../../../helpers/tables'
import { copyValue } from '../../../helpers/extractor'
import { TaxFundPermissions } from '../../../helpers/enum'
import Access from '../../../mixins/utils/Access'
import { format } from 'date-fns'
export default {
  components: {
    Full,
    CustomCard,
    TaxFundEntry,
    DeleteConfirmation
  },
  mixins: [ TaxFundApi, tables, Access ],
  TaxFundPermissions,
  data() {
    return {
      entryMode: 'Add',
      showModalEntry: false,
      showModalConfirmation: false,
      forms: {
        taxFund: {
          isProcessing: false,
          fields: { ...taxFundFields },
          states: { ...taxFundFields },
          errors: { ...taxFundFields },
        }
      },
      tables: {
        taxFunds: {
          isBusy: false,
          fields: [
            {
              key: 'description',
              label: 'Description',
              tdClass: 'align-middle',
              thStyle: { width: 'auto' },
              sortable: true
            },
            {
              key: 'createdByUser.userable.name',
              label: 'Created By',
              tdClass: 'align-middle',
            },
            {
              key: 'createdAt',
              label: 'Created Datetime',
              tdClass: 'align-middle',
              thStyle: { width: '250px' },
              formatter: (value) => {
                return format(new Date(value), 'MM/dd/yyyy h:mm a')
              }
            },
            {
              key: 'previousBalance',
              label: 'Prev Balance',
              thClass: 'text-right',
              tdClass: 'align-middle text-right',
              thStyle: { width: '200px' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'debit',
              label: 'Debit',
              thClass: 'text-right',
              tdClass: 'align-middle text-right',
              thStyle: { width: '200px' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'credit',
              label: 'Credit',
              thClass: 'text-right',
              tdClass: 'align-middle text-right',
              thStyle: { width: '200px' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'balance',
              label: 'Balance',
              thClass: 'text-right',
              tdClass: 'align-middle text-right',
              thStyle: { width: '200px' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
          ],
          items: []
        }
      },
      filters: {
        taxFund: {
          criteria: null,
          fromDate: null,
          toDate: null
        }
      }
    }
  },
  created() {
    this.loadTaxFund()
  },
  methods: {
    loadTaxFund() {
      const { dateFrom, dateTo } = this.filters.taxFund
      const params = {
        paginate: false,
        dateFrom,
        dateTo
      }
      const { taxFunds } = this.tables
      taxFunds.isBusy = true
      this.getTaxFundList(params)
      .then(({ data }) => {
        taxFunds.items = data
        taxFunds.isBusy = false
      })
    },
    onTaxFundEntry(){
      const { taxFund, taxFund: { fields } } = this.forms
      const { taxFunds } = this.tables
      taxFund.isProcessing = true
      reset(taxFund)
      if(this.entryMode == "Add"){
        this.addTaxFund(fields)
          .then(({ data }) => {
            taxFunds.items.push(data)
            taxFund.isProcessing = false
            showNotification(this, "success", "Tax fund created successfully.")
            this.showModalEntry = false
          })
          .catch(error => {
            const errors = error.response.data.errors
            taxFund.isProcessing = false
            validate(taxFund, errors)
          })
      }
      else {
        const { fields } = this.forms.taxFund
        this.updateTaxFund(fields, fields.id)
          .then(({ data }) => {
            this.updateRow(taxFunds, data)
            taxFund.isProcessing = false
            showNotification(this, "success", "Tax Fund updated successfully.")
            this.showModalEntry = false
          })
          .catch(error => {
            const errors = error.response.data.errors
            taxFund.isProcessing = false
            validate(taxFund, errors)
          })
      }
    },
    onTaxFundDelete(){
      const { taxFund, taxFund: { fields: { id } } } = this.forms
      const { taxFunds } = this.tables
      taxFund.isProcessing = true
      this.deleteTaxFund(id)
        .then(({ data }) => {
          taxFund.isProcessing = false
          showNotification(this, "success", "Tax Fund deleted successfully.")
          this.showModalConfirmation = false
        })
        .catch(error => {
          const errors = error.response.data.errors
          taxFund.isProcessing = false
          if(errors.msg) {
            showNotification(this, "danger", errors.msg)
          }
        })
    },
    setUpdate(row){
      this.showModalEntry = true
      const { taxFund, taxFund: { fields } } = this.forms
      taxFund.isLoading = true
      copyValue(row.item, fields)
      reset(taxFund)
      this.entryMode = "Edit"
      taxFund.isLoading = false
    },
    setCreate() {
      const { taxFund } = this.forms
      taxFund.fields.debit = 0
      taxFund.fields.credit = 0
      clearFields(taxFund)
      reset(taxFund)
      this.entryMode = "Add"
      this.showModalEntry = true
    },
    setDelete(id) {
      const { fields } = this.forms.taxFund
      fields.id = id
      this.showModalConfirmation = true
    },
    onChangeDateFilters() {
      const { dateFrom, dateTo } = this.filters.taxFund

      if (dateFrom && dateTo) {
        this.loadTaxFund()
      }
    }
  }
}
</script>

<style lang="scss">
  .tax-fund__filter {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;

    .tax-fund__label {
      width: 35px;
      text-align: center;
      align-items: center;
    }

    .tax-fund__date-picker {
      width: 250px;
    }
  }
</style>